import {API, _addAuthToUrl, getBackendUrl} from '@utils'
import axios from 'axios'
//************************************//
import _ from "lodash"
//************************************//
export const _getAssetList = ({limit, page, sort, filter, withSavedQueries}, callback) => {
	API.get('/assets/list', {
		params: {
			limit,
			page,
			sort,
			filter,
			with_saved_queries: withSavedQueries
		}
	})
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _getAssetArchiveList = ({limit, page, sort, filter, withSavedQueries}, callback) => {
	API.get('/assets/archive', {
		params: {
			limit,
			page,
			sort,
			filter,
			with_saved_queries: withSavedQueries
		}
	})
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _searchAsset = async (q = '', with_fields = false) => {
	const {data} =  await API.get('/assets/search', {
    params: {
			limit: 50,
      q,
			with_fields
    }
  })
  const result = _.map(data, (v, k) => {
    return {...v, value: v.id, label: v.asset_id, displayName: v.display_name}
  })
  return result
}
//************************************//
export const _showAsset = (uuid, callback) => {
  API.get(`/assets/${uuid}`, {
		params: {
			fields_as_object: true
		}
	})
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _addAsset = (data, callback, callbackError) => {
	API.post('/assets/new', data)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function ({data}) {
		if (callbackError) callbackError(data?.data)
	})
}
//************************************//
export const _updateAsset = (uuid, data, callback, callbackError) => {
	API.put(`/assets/${uuid}`, data)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function ({data}) {
		if (callbackError) callbackError(data?.data)
	})
}
//************************************//
export const _archiveAsset = (uuid, callback) => {
	API.delete(`/assets/${uuid}`)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
export const _archiveBulkAsset = (params, callback) => {
	API.put(`/assets/bulk-archive`, params)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
export const _restoreBulkAsset = (params, callback) => {
	API.put(`/assets/bulk-restore`, params)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _restoreAsset = (uuid, callback) => {
	API.put(`/assets/${uuid}/restore`)
		.then(function ({data}) {
			callback(data)
		})
		.catch(function (res) {})
}
//************************************//
export const _restoreType = (uuid, callback) => {
	API.put(`/assets/types/${uuid}/restore`)
		.then(function ({data}) {
			callback(data)
		})
		.catch(function (res) {})
}
//************************************//
export const _restoreBulkType = (params, callback) => {
	API.put(`/assets/types/bulk-restore`, params)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}

//************************************//
export const _getTypeList = ({limit, page, sort, filter}, callback) => {
	API.get('/assets/types/list', {
		params: {
			limit,
			page,
			sort,
			filter
		}
	})
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _getTypeArchiveList = ({limit, page, sort, filter}, callback) => {
	API.get('/assets/types/archive', {
		params: {
			limit,
			page,
			sort,
			filter
		}
	})
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _getAllAssetTypes = (callback) => {
  API.get('/assets/types/all')
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _findTypes = (callback) => {
	API.get('/assets/types/all', {
		params: {
			limit: 1
		}
	})
		.then(function ({data}) {
			callback(data)
		})
		.catch(function (res) {})

}
//************************************//
export const _searchTypes = async (q = '') => {
  const res =  await API.get('/assets/types/all', {
    params: {
      limit: 20,
      q
    }
  })
  const result = _.map(res.data, (v, k) => {
    return {value: v.id, label: v.name, uuid: v.uuid}
  })
  return result
}
//************************************//
export const _getAllTypesWithFields = (callback) => {
  API.get('/assets/types/all', {
    params: {
     with_fields: true
    }
  }).then(({data}) => callback(data))
}
//************************************//
export const _addType = (data, callback, callbackError) => {
	API.post('/assets/types/new', data)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function ({data}) {
		if (callbackError) callbackError(data?.data)
	})
}
//************************************//
export const _archiveType = (uuid, callback) => {
	API.delete(`/assets/types/${uuid}`)
	.then(function ({data}) {
		callback(data)
	})
	.catch(function (res) {})
}
//************************************//
export const _showAssetType = (uuid, callback) => {
	API.get(`/assets/types/${uuid}`)
		.then(function ({data}) {
			callback(data)
		})
		.catch(function (res) {})
}
//************************************//
export const _updateAssetType = (uuid, data, callback) => {
	API.put(`/assets/types/${uuid}`, data)
		.then(function ({data}) {
			callback(data)
		})
		.catch(function (res) {})
}
//************************************//
export const _deleteUnusedCustomField = async (id, callback) => {
	const res =  await API.delete(`/assets/types/unused-fields/${id}/delete`)
	return res.data
	// API.put(`/assets/types/unused-fields/${id}/delete`)
	// 	.then(function ({data}) {
	// 		callback(data)
	// 	})
	// 	.catch(function (res) {})
}
//************************************//
export function _sendAssetsImportedFile(type_id, data, callback, callbackErr, finishCallback) {
	const formData = new FormData()
	formData.append('file', data.file)
	const finalColumns = []
	_.forEach(data.columns, (x, key) => {
		finalColumns.push({id: key, index: x})
	})
	formData.append('columns', JSON.stringify(finalColumns))
	formData.append('type_id', type_id)
	// console.log(JSON.stringify(finalColumns))
	// return
	API.post(`/assets/bulk-import`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
		.then(function ({data}) {
			callback(data)
		})
		.catch(function ({data}) {
			callbackErr(data)
		})
		.finally(() => finishCallback())
}
//************************************//
export const _searchAssetTypes = async (q = '') => {
  const res =  await API.get('/assets/types/all', {
    params: {
      limit: 20,
      q,
			with_fields: true
    }
  })
  const result = _.map(res.data, (v, k) => {
    return {value: v.id, label: v.name, fields: v.fields}
  })
  return result
}
//************************************//
export const _getAssetTypesByIds = (ids = [], callback) => {
	API.get(`/assets/types/all`, {
    params: {
      ids,
			with_fields: true
    }
  })
	.then(function ({data}) {
		const result = _.map(data, (v, k) => {
			return {value: v.id, label: v.name, fields: v.fields}
		})
		callback(result)
	})
	.catch(function (res) {})
}